export const SELECT_STORES_TABLE_ID = 31;